// `WebApplication` JSON-LD — Schema.org type for the homepage that
// declares Morfi as a finance-category web app. Eligibility for:
//   - Google App-card SERP entries (rare but lucrative for branded queries)
//   - "Free to use" / pricing labels in branded search
//   - Knowledge graph signals tying the app to the publisher Organization
//
// Only emit on the homepage — every other page has its own surface
// JSON-LD and adding a WebApplication node there would dilute the signal.

import copy from '../copy';
import { organizationId } from './site';
import type { JsonLdNode } from './types';

export function buildWebApplicationJsonLd(opts: {
  pageUrl: string;
  ogImageUrl: string;
  description: string;
}): JsonLdNode {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebApplication',
    '@id': `${opts.pageUrl}#webapplication`,
    name: copy.webApplication.name,
    alternateName: copy.webApplication.alternateName,
    url: opts.pageUrl,
    description: opts.description,
    image: opts.ogImageUrl,
    applicationCategory: 'FinanceApplication',
    applicationSubCategory: 'OpinionMarkets',
    operatingSystem: 'Web',
    browserRequirements: copy.webApplication.browserRequirements,
    publisher: { '@id': organizationId() },
    // Offer node makes the "Free to use" label render on Google's app
    // cards. Trading itself isn't free (network fees) but the platform
    // has no subscription / install fee.
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'USD',
      availability: 'https://schema.org/InStock',
    },
    featureList: [...copy.webApplication.features],
  };
}
